/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";

export class PointModel extends JsonModel<PointModel.IJson> {
  public get x(): number {
    return this.json.x;
  }

  public get y(): number {
    return this.json.y;
  }
}

export namespace PointModel {
  export interface IJson {
    x: number;
    y: number;
  }
}
/* v8 ignore stop */
